import React, { useCallback, useEffect, useState } from 'react';
import { Box, Button, Snackbar, SnackbarContent, Grid, Link } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import ConsentStore, { REOPEN_BANNER_EVENT } from '../store/ConsentStore';
import SpacerHorizontal from './helpers/SpacerHorizontal';
import SpacerVertical from './helpers/SpacerVertical';
import { useTranslation } from 'react-i18next';

const CookieMessage = () => {
  const [open, setOpen] = useState(!ConsentStore.hasDecided());
  const { t } = useTranslation();

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener(REOPEN_BANNER_EVENT, handler);
    return () => window.removeEventListener(REOPEN_BANNER_EVENT, handler);
  }, []);

  const accept = useCallback(() => {
    if (ConsentStore.setMarketingConsent(true)) {
      setOpen(false);
    }
  }, []);

  const deny = useCallback(() => {
    if (ConsentStore.setMarketingConsent(false)) {
      setOpen(false);
    }
  }, []);

  return (
    <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={open}>
      <SnackbarContent
        message={
          <Grid container wrap="nowrap" alignItems="flex-start">
            <InfoIcon />
            <SpacerHorizontal size="small" />
            <Box>
              <Box fontWeight="fontWeightBold">{t('cookieMessage.title')}</Box>
              <Box>{t('cookieMessage.message')}</Box>
              <Box>{t('cookieMessage.description')}</Box>
              <SpacerVertical size="small" />
              <Link
                href={t('links.privacyPolicy')}
                target="_blank"
                rel="noopener noreferrer"
                color="inherit"
                underline="always"
              >
                {t('cookieMessage.privacyPolicyLink')}
              </Link>
            </Box>
          </Grid>
        }
        action={
          <Grid container direction="column" spacing={1} wrap="nowrap">
            <Grid item>
              <Button variant="contained" color="primary" onClick={accept} fullWidth>
                {t('cookieMessage.buttonAccept')}
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                onClick={deny}
                fullWidth
                style={{ backgroundColor: '#ffffff', color: '#000000' }}
              >
                {t('cookieMessage.buttonDeny')}
              </Button>
            </Grid>
          </Grid>
        }
      />
    </Snackbar>
  );
};

export default CookieMessage;
